var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitoringIconBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#0048B6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9205_88296",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9205_88296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.334 35.6676V33.4753L14.334 31.4753V35.6676H12.334ZM17.6673 35.6676V28.1419L19.6673 26.1419V35.6676H17.6673ZM23.0007 35.6676V26.1419L25.0007 28.1753V35.6676H23.0007ZM28.334 35.6676V28.1753L30.334 26.1753V35.6676H28.334ZM33.6673 35.6676V22.8086L35.6673 20.8086V35.6676H33.6673ZM12.334 28.2933V25.4753L21.334 16.4753L26.6673 21.8086L35.6673 12.8086V15.6266L26.6673 24.6266L21.334 19.2933L12.334 28.2933Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringIconBlue);
export default __webpack_public_path__ + "static/media/monitoring_icon_blue.06c45a7d8fad6c50a8818eed5221938c.svg";
export { ForwardRef as ReactComponent };